import { ReactElement } from 'react';
import BigNumber from 'bignumber.js';

import { StakeForm } from 'modules/dashboard';
import { Dialog, KnownDialogs, useDialog } from 'modules/dialogs';
import { useTranslation } from 'modules/i18n';

import { translation } from './translation';

export function BoostDialog(): ReactElement {
  const { isOpened, onClose } = useDialog(KnownDialogs.boostRewards);
  const { t, keys } = useTranslation(translation);

  const REWARDS_AMOUNT = new BigNumber(1);

  return (
    <Dialog header={t(keys.stake)} open={isOpened} onClose={onClose}>
      <StakeForm stakeAmount={REWARDS_AMOUNT} />
    </Dialog>
  );
}
